import type { HTMLAttributes } from 'react'
import cx from 'classnames'
import styles from './OneLine.module.css'

interface OneLineProps extends HTMLAttributes<HTMLSpanElement> {}

/**
 * Text that is truncated to a single line.
 */
export function OneLine({ className, ...rest }: OneLineProps) {
  return <span className={cx(styles.root, className)} {...rest} />
}
